import styled from "styled-components";

export const ModalBody = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ToggleLabel = styled.span<{ bold?: boolean }>`
  font-size: 13px;
  font-weight: ${({ bold }) => (bold ? "600" : "400")};
  color: #333;
`;

export const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  cursor: pointer;
  margin-bottom: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 24px;
    transition: 0.3s;

    &::before {
      content: "";
      position: absolute;
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background: white;
      border-radius: 50%;
      transition: 0.3s;
    }
  }

  input:checked + span {
    background-color: ${({ theme }) => theme.colors.project.main};
  }

  input:checked + span::before {
    transform: translateX(20px);
  }
`;
